var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbank24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#120063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44393 17.1899H7.71812L6.56893 18.5206V17.1899H5.98828V20.0932H6.56893V18.7625L7.75441 20.0932H8.48022L7.18586 18.6416L8.44393 17.1899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87092 18.0125C9.62899 18.0125 9.42334 18.1214 9.25399 18.2666V17.1899H8.67334V19.1012C8.67334 19.6819 9.06044 20.1657 9.77415 20.1657C10.4153 20.1657 10.875 19.7182 10.875 19.1012C10.8629 18.5085 10.4758 18.0125 9.87092 18.0125ZM9.76205 19.6456C9.45963 19.6456 9.21769 19.4037 9.21769 19.1133V19.1012C9.21769 19.0407 9.22979 18.9803 9.24189 18.9198C9.31447 18.702 9.52011 18.5448 9.76205 18.5448C10.0645 18.5448 10.3064 18.7867 10.3064 19.0891C10.3064 19.3916 10.0645 19.6456 9.76205 19.6456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.952 18.0127C14.6738 18.0127 14.4561 18.1095 14.2867 18.2667V18.0732H13.7061V19.5611V20.0933H14.2746H14.2867V18.9562C14.2867 18.7264 14.4802 18.5329 14.7101 18.5329C14.9399 18.5329 15.1335 18.7264 15.1335 18.9562V20.0812V20.0933H15.7141V18.799C15.7141 18.7869 15.7141 18.7869 15.7141 18.7748C15.7262 18.3514 15.3754 18.0127 14.952 18.0127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2428 18.0127C11.5896 18.0127 11.1299 18.4603 11.1299 19.0772C11.1299 19.67 11.5291 20.1538 12.1339 20.1538C12.4121 20.1538 12.6783 20.0087 12.8234 19.803V20.0812H13.3436V19.0651C13.3436 19.053 13.3436 19.053 13.3436 19.053C13.3557 18.4966 12.9686 18.0127 12.2428 18.0127ZM12.2549 19.6337C11.9525 19.6337 11.7105 19.3917 11.7105 19.0893C11.7105 18.7869 11.9525 18.545 12.2549 18.545C12.5573 18.545 12.7992 18.7869 12.7992 19.0893C12.8113 19.3917 12.5694 19.6337 12.2549 19.6337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0129 20.0689L17.1419 19.0648L17.9887 18.0729H17.3597L16.6339 18.9318V17.1777H16.0532V20.0689H16.6339V19.1979L17.3839 20.0689H18.0129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5806 5.68577L12 8.41964L8.41936 5.68577L6 3.83496V6.78657V15.5083H8.41936V8.66157L12 11.4438L15.5806 8.66157V15.5083H18V6.78657V3.83496L15.5806 5.68577Z",
    fill: "#BCF100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbank24);
export default __webpack_public_path__ + "static/media/Kbank-24.a70de04377a3ae88b8b50ccc3b69a138.svg";
export { ForwardRef as ReactComponent };